export const environment = {
    production: true,
    apiBaseUrl: 'https://serviciosautinterconexion.oaj.gob.mx/',
    gateway: 'oaj.icoij.gateway',
    api: 'oaj.icoij.api.itx',
   // host:"https://serviciosautinterconexion.oaj.gob.mx/oaj.captcha.gateway/", // captcha
    host:"https://captcha.oaj.gob.mx/",
    FilterCourtURL: 'https://serviciosautinterconexion.oaj.gob.mx/wsCatalogoEEAPI/catalogoapi/',
    baseUrlFirma: 'https://interconexion.oaj.gob.mx/PSSIcoij/signAPI.html',    
    TipoDoctos: {
     Promociones: 234,
        Demandas: 235,
        Notificaciones: 236,
        Incidencias: 238,
        DiasInhabiles: 239,
        autoEnrolamiento: 240,
        TerminosyCondiciones: 241
    },
    //Expediente Electronico Interconexion
    apiBaseUrlItxEE: 'https://serviciosautinterconexion.oaj.gob.mx/',
    gatewayItxEE: 'oaj.icoij.api.ee',
    RutaVistaEE: 'https://ejusticia.cjf.gob.mx/vistaee/#?',
    //Visor
    apiBaseUrlVisor: 'https://serviciosautinterconexion.oaj.gob.mx/',
    wsdocumentviewerVisor: 'oaj.sisefiles.gateway',
    idDocumentoTerminoyCondiciones: '639081499334039661',
    ipAddress: {
        URL_API: "https://api.ipify.org/?format=json",
    },
    // Firma
  signData: {
    plantilla: false,
    accept: '.pdf',
    signs: 1,
    documentosShowDetails: false,
    documentos: { numPaginas: 10000, tamanio: 40 },
    mail: {
      email: "siat@cjf.gob.mx",
      pwd: "Edr4fg..#22",
      copy: "",
      to: "siat@cjf.gob.mx",
    },
    leyendas: {
      pfx: 'Elija el tipo de certificado de la firma electrónica aceptada que desea utilizar. Si utilizará la firma FIREL o FIRMA.JUDICIAL, deberá seleccionar el certificado digital PFX Si cuenta con la firma E.FIRMA, FEJEM, FIREC, FELAVA, FEJUD o FECPJG, deberá seleccionar el certificado digital CER, en conjunto con la llave privada KEY.',
      keyCer: 'Elija el tipo de certificado de la firma electrónica aceptada que desea utilizar. Si utilizará la firma FIREL o FIRMA.JUDICIAL, deberá seleccionar el certificado digital PFX Si cuenta con la firma E.FIRMA, FEJEM, FIREC, FELAVA, FEJUD o FECPJG, deberá seleccionar el certificado digital CER, en conjunto con la llave privada KEY.',
      miniPfx: 'FIREL y FIRMA.JUDICIAL',
      minikeyCer: 'E.FIRMA, FEJEM, FIREC, FELAVA, FEJUD y FECPJG'
    },
    // new param
    maxSizeUploadFile: 100,
    maxSizePerFile: 50,
    chunkSize: 5,
     dragAndDrop: true, // Activa el arrastre de documentos para cargarlo al inicio. default true
    docxPreview: true, // Agrega la vista previa del documento en el modal
  },
  archivoTerminosCondiciones: '1580239639081499334039661',
  siteFirma:'/',
  apiBaseUrlSite: 'https://firma.oaj.gob.mx',
  apiBaseUrlUNC: 'https://serviciosunc.cjf.gob.mx/',
};